/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { UploadStatus, FileUploadMetaSimple } from 'cio/utils/asset-library';

interface AssetLibraryBulkUploadPopupArgs {
  uploads: FileUploadMetaSimple[];
  hideProgressBar: boolean;
  previousBatchUploadsCount: number;
  onClose: () => unknown;
}

export default class AssetLibraryBulkUploadPopup extends Component<AssetLibraryBulkUploadPopupArgs> {
  @tracked expandedUploadQueue = true;
  @tracked mouseIsInsideUploadQueueList = false;

  get uploadItemsTotal(): number {
    return this.args.uploads.length;
  }

  get uploadItemsSucceeded(): number {
    return this.args.uploads.filter((uploadMeta) => uploadMeta.status === UploadStatus.Success).length;
  }

  get uploadItemsErrored(): number {
    return this.args.uploads.filter((uploadMeta) => uploadMeta.status === UploadStatus.Error).length;
  }

  get uploadItemsProcessed(): number {
    return this.uploadItemsSucceeded + this.uploadItemsErrored;
  }

  get uploadItemsToProcess(): number {
    return this.uploadItemsTotal - this.uploadItemsProcessed;
  }

  get uploadProgressBarPercentage(): number {
    let processed = this.uploadItemsProcessed - this.args.previousBatchUploadsCount;
    let total = this.uploadItemsTotal - this.args.previousBatchUploadsCount;

    return Math.round((processed / total) * 100);
  }

  get uploadProgressBarStyle(): string {
    return `width: ${this.uploadProgressBarPercentage}%;`;
  }

  get isUploading(): boolean {
    return this.uploadItemsToProcess > 0;
  }

  @action
  onExpandCollapseClick() {
    this.expandedUploadQueue = !this.expandedUploadQueue;
    if (!this.expandedUploadQueue) {
      this.mouseIsInsideUploadQueueList = false;
    }
  }

  @action
  scrollElementIntoView(element: Element) {
    if (!this.mouseIsInsideUploadQueueList) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
    }
  }
}
